<template>
    <h3 class="helvetica title3">{{ formmattedDayDate }}</h3>
</template>

<script lang="ts" setup>
const props = defineProps<{ day_date: any }>()
const formmattedDayDate = computed(() => {
    if (props.day_date) return new Date(props.day_date).toLocaleDateString('en-GB', { month: 'short', day: 'numeric' })
    else return null
})
</script>